import { __decorate } from "tslib";
import 'jquery';
import 'whatwg-fetch';
import '@gn-audio/ui/javascript/jquery.lazyloadxt.js';
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { FallbackSrcComponentNgModule } from '@gn-audio/angularjs-components/fallback-src';
import { PriceComponentNgModule } from '@gn-audio/angularjs-components/price';
import { ProductComponentNgModule } from '@gn-audio/angularjs-components/product';
import { ProductActionComponentNgModule } from '@gn-audio/angularjs-components/product-action';
import { ProductsComponentNgModule } from '@gn-audio/angularjs-components/products';
import { ScrollToComponentNgModule } from '@gn-audio/angularjs-components/scroll-to';
import { SyncModelComponentNgModule } from '@gn-audio/angularjs-components/sync-model';
import { LocaleComponentNgModule } from '@gn-audio/angularjs-components/locale';
import { WasThisUsefulComponentNgModule } from '@gn-audio/angularjs-components/was-this-useful';
import { AccessoriesModule } from 'src/Feature/Accessories/app';
import { BluetoothPairingGuideModule } from 'src/Feature/BluetoothPairingGuide/app';
import { BreadcrumbsModule } from 'src/Feature/Breadcrumbs/app';
import { ContactSupportModule } from 'src/Feature/ContactSupport/app';
import { CustomizerModule } from 'src/Feature/Customizer/app';
import { DocumentsModule } from 'src/Feature/Documents/app';
import { FaqModule } from 'src/Feature/Faq/app';
import { ProductSelectorModule } from 'src/Feature/ProductSelector/app';
import { SerialNumberLocatorModule } from 'src/Feature/SerialNumberLocator/app';
import { SoftwareModule } from 'src/Feature/Software/app';
import { StaffModule } from 'src/Feature/Staff/app';
import { VideosModule } from 'src/Feature/Videos/app';
import { ProductFinderModule } from 'src/Feature/ProductFilterModule/app';
import { DynamicPagesModule } from 'src/Foundation/DynamicPages/app';
import { TranslationModule } from 'src/Foundation/Translation/app';
import { SearchModule } from 'src/Feature/Search/app';
import { ReplaceTokensDirective } from './directives/replace-tokens.directive';
import { SetupAndPairingSectionController } from './setup-and-pairing-section/setup-and-pairing-section.controller';
import { MarketLocaleInterceptor } from './interceptors/market-locale-interceptor';
import { CoveoAnalyticsWrapperComponent } from './coveo-analytics-wrapper/coveo-analytics-wrapper';
import { CoveoAnalyticsComponentNgModule } from '@gn-audio/angularjs-components/coveo-user-analytics';
var moduleId = 'gn.audio.support';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('SetupAndPairingSectionController', SetupAndPairingSectionController)
    .directive('replaceTokens', ReplaceTokensDirective);
var ShellModule = (function () {
    function ShellModule() {
    }
    ShellModule.config = function ($sceProvider, $httpProvider, $locationProvider, wasThisUsefulProvider, apiLanguage, wasThisUsefulApiUrl, siteContext) {
        'ngInject';
        $sceProvider.enabled(false);
        $httpProvider.interceptors.push("MarketLocaleInterceptor");
        $locationProvider.hashPrefix('');
        wasThisUsefulProvider.baseUrl(wasThisUsefulApiUrl)
            .marketLocale(apiLanguage)
            .siteContext(siteContext);
    };
    ShellModule = __decorate([
        NgModule({
            declarations: [
                CoveoAnalyticsWrapperComponent
            ],
            id: moduleId,
            imports: [
                'gn.audio.support.productapi',
                TranslationModule,
                ProductSelectorModule,
                SoftwareModule,
                DocumentsModule,
                FaqModule,
                CustomizerModule,
                AccessoriesModule,
                VideosModule,
                ProductFinderModule,
                SerialNumberLocatorModule,
                ContactSupportModule,
                StaffModule,
                BluetoothPairingGuideModule,
                BreadcrumbsModule,
                DynamicPagesModule,
                SearchModule,
                legacyModuleId,
                LocaleComponentNgModule.name,
                FallbackSrcComponentNgModule.name,
                PriceComponentNgModule.name,
                ProductComponentNgModule.name,
                ProductActionComponentNgModule.name,
                ProductsComponentNgModule.name,
                ScrollToComponentNgModule.name,
                SyncModelComponentNgModule.name,
                WasThisUsefulComponentNgModule.name,
                CoveoAnalyticsComponentNgModule.name,
            ],
            providers: [
                MarketLocaleInterceptor,
            ],
        })
    ], ShellModule);
    return ShellModule;
}());
export { ShellModule };
